// extracted by mini-css-extract-plugin
export var layoutContainer = "_90-0";
export var layoutContainerNoRounding = "_90-6";
export var layoutContainerOpen = "_90-5";
export var layoutContainerResizing = "_90-1";
export var mainContent = "_90-2";
export var resizeDivider = "_90-3";
export var slidePanel = "_90-4";